import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Input, Textarea } from '@Sage/hoi-poi-ui';

import { getLiteral } from 'utils/getLiteral';

const IntegrationConfigurationInput = memo(
    ({
        literal,
        onChange,
        value = '',
        objName,
        maxLength,
        errorText = {},
        hintText,
        multiline,
        rows,
        optional,
    }) => {
        const literalError = errorText[objName] || '';
        const label = useMemo(() => getLiteral(literal), [literal]);
        const isRequired = !optional;

        const handleChange = useCallback(
            (newValue) => {
                let text = newValue ?? '';
                if (maxLength && text.length > Number(maxLength)) {
                    text = text.slice(0, Number(maxLength));
                }
                onChange?.(text);
            },
            [maxLength, onChange],
        );

        const placeholder = getLiteral(hintText || 'placeholder_text_field');

        const fieldProps = {
            id: `input_${objName}`,
            className: 'integration-configuration-field',
            value,
            onChange: handleChange,
            error: literalError ? getLiteral(literalError) : undefined,
            isFullWidth: true,
            isRequired,
            label,
            labelMode: 'vertical',
            placeholder,
            placeholderReadOnly: placeholder,
            ...(maxLength ? { maxLength: Number(maxLength) } : {}),
        };

        return (
            <div className="mailchimp-configuration-input">
                {multiline ? (
                    <Textarea {...fieldProps} minRows={rows ? Number(rows) : 2} />
                ) : (
                    <Input {...fieldProps} />
                )}
            </div>
        );
    },
);

IntegrationConfigurationInput.displayName = 'IntegrationConfigurationInput';

IntegrationConfigurationInput.propTypes = {
    errorText: PropTypes.object,
    hintText: PropTypes.string,
    literal: PropTypes.string.isRequired,
    maxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    multiline: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    objName: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    optional: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.string,
};

export default IntegrationConfigurationInput;
